export default {
      id: "ic_image-usage",
      viewBox: "0 0 14 13",
      url: "/" + "images/icons.3.109.2.svg#ic_image-usage",
      toString: function () {
        return this.url;
      }
    }